import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/mockData";

const FAQ = () => {
  return (
    <section id="faq" className="border-t border-white/5">
      <div className="max-w-4xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <p className="text-xs uppercase tracking-[0.2em] text-blue-400 mb-3">FAQ</p>
        <h2
          className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter text-zinc-50"
          data-testid="faq-heading"
        >
          Questions, asked and answered.
        </h2>

        <Accordion type="single" collapsible className="mt-10 divide-y divide-white/5">
          {FAQS.map((f, i) => (
            <AccordionItem
              value={`item-${i}`}
              key={f.q}
              className="border-b-0"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left text-base font-medium text-zinc-100 hover:text-blue-300 hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-zinc-400 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
